import { Component, OnInit } from '@angular/core';
import { PessoaFisicaCategoriaHabilitacaoLabels } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-fisica-categoria-habilitacao.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-categoria-cnh',
  templateUrl: './dropdown-categoria-cnh.component.html',
  styleUrls: ['./dropdown-categoria-cnh.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownCategoriaCnhComponent implements OnInit {

  tipoCategoria = PessoaFisicaCategoriaHabilitacaoLabels;

  constructor() {}

  ngOnInit() {}

}
